<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="" style="margin-top: 10px;">
  <div class="row">
    <div class="col-sm-4">
    </div>
    <div class="col-sm-8 action-buttons-container">
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.dataGridAdmin"
        (click)="openReorder()" (keydown.enter)="openReorder()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openAddPopup()"
        (keydown.enter)="openAddPopup()">
        <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white">Add New</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Excel')"
        (keydown.enter)="openReport('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
        (keydown.enter)="openReport('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
        (keydown.enter)="openAuditTrail('overAll',0)">
        <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Audit Trail</span>
      </div>
      <div class="reloadIconContiner" (click)="refreshGridData()" (keydown.enter)="refreshGridData()"
        matTooltip="Refresh Grid">
        <i class="fas fa-redo-alt"></i>
      </div>
    </div>
  </div>
</div>

<div class="table-container">
  <table class="dynamic-table-container">
    <th style="min-width: 60px; text-align: center;"
      [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
      <div style="display: flex;">
        <div>
          <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
        </div>
      </div>
    </th>
    <th id="grid-header-container"
      *ngFor="let trainingGroupTrainingDataForGrid of columnLists.fieldColumnarray; let ix = index;"
      [ngStyle]="{'min-width': trainingGroupTrainingDataForGrid.width}"
      class="sticky-dynamic-col1 dynamic-table-header-style">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>{{ trainingGroupTrainingDataForGrid.fieldColumnarray }}</span>
        <div class="d-flex gap-2 align-items-center">
          <div (click)="sortColumn(columnLists.columnsListarray[ix],trainingGroupTrainingDataForGrid)"
            (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],trainingGroupTrainingDataForGrid)">
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th id="menu" class="sticky-col first-col"></th>
    <tr>
      <td [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
      <td *ngFor="
                let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray;
                let ix = index
              " [ngStyle]="{
                'min-width':
                  oneQmsUsersDataForTable1Data.width != null
                    ? oneQmsUsersDataForTable1Data.width
                    : '200px'
              }" class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="cssfunction(0)">
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" />
        </div>
      </td>
    </tr>
    <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
      [class.highlightRow]="list.childCheckBoxs == true">
      <td style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, list, idx)">
          </div>
        </div>
      </td>
      <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
        class="sticky-dynamic-row1" [ngStyle]="{
        'max-width': key.width[i],
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
        'cursor': 'pointer'}" matTooltip="{{ list[key.columnsListarray] }}">
        <span *ngIf="key.dataType=='CHECKBOX'">
          <div class="gridCheckBoxes">
            <img *ngIf="list[key.columnsListarray]" src="../../../../assets/img/accessSymbol.svg" alt="Yes" width="20"
              height="20">
            <img *ngIf="list[key.columnsListarray]==false" src="../../../../assets/img/noAcessSymbol.svg" alt="No"
              width="20" height="20">
          </div>
        </span>
        <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'">{{ list[key.columnsListarray] }}</span>
        <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
      </td>
      <td class="sticky-col first-col">
        <div class="action-icons">
          <i class="fa-solid fa-pencil" matTooltip="Edit Group Training" style="margin-left: 5px;"
            (click)="openEditPopup(list)" (keydown.enter)="openEditPopup(list)"></i>
          <i class="fa-sharp fa-solid fa-trash" title="Delete" style="margin-left: 5px;" (click)="openDeletePopup(list)"
            (keydown.enter)="openDeletePopup(list)"></i>
          <span class="active-inActiveUsers" *ngIf="list.IS_ACTIVE" style="color: red;"
            (click)="openActiveAndInActivePopup(list)" (keydown.enter)="openActiveAndInActivePopup(list)"
            matTooltip="Inactivate">
            <i class="fas fa-lock"></i>
          </span>
          <span class="active-inActiveUsers" *ngIf="!list.IS_ACTIVE" style="color: green;"
            (click)="openActiveAndInActivePopup(list)" (keydown.enter)="openActiveAndInActivePopup(list)"
            matTooltip="Activate">
            <i class="fas fa-lock-open"></i>
          </span>
          <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
            src="../../assets/img/trail-individual.svg" (keydown.enter)="openAuditTrail('individual',list)"
            (click)="openAuditTrail('individual',list)" />
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <div class="col-md-6" id="search-container">
          <!-- Training -->
          <div><label for="email">{{dynamicLabel['TRAINING_NAME']}}</label><span class="mandatory-symbol">*</span> <i
              *ngIf="trainingGroupTrainingFieldData.trainingName!='' && trainingGroupTrainingFieldData.trainingName!=null"
              class="fa fa-eye eye" (click)="getClobData(trainingGroupTrainingFieldData.trainingName)"
              (keydown.enter)="getClobData(trainingGroupTrainingFieldData.trainingName)"></i></div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-11" style="position: relative;">
              <input id="trainingName" class="input-filed-continers" type="text" style="cursor: not-allowed;"
                [matTooltip]="trainingGroupTrainingFieldData.trainingName"
                [(ngModel)]="trainingGroupTrainingFieldData.trainingName" disabled>
            </div>
            <div class="col-sm-1" *ngIf="!visibleEditButton"
              style="padding-left: 2%; margin-top: 1%; font-size: 16px; color: red; cursor: pointer;"
              (click)="searchTrainingFunction()" (keydown.enter)="searchTrainingFunction()">
              <i class="fa fa-search"></i>
            </div>
          </div>
          <span id="trainingName-required-msg">Please search training</span>
        </div>
        <div class="col-md-3">
          <!-- Training Level -->
          <div>
            <label for="email">{{dynamicLabel['TRAINING_LEVEL']}}</label><span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput placeholder="Select" id="trainingLevel" [(ngModel)]="selectedTrainingLevel"
            [ngClass]="{'odd-item-mat-select': oddTrainingLevel == selectedTrainingLevel}"
            (closed)="trianingLevelsearchTxt=''" (click)="focusmethod('trianingLevelfocusSearch')"
            (keydown.enter)="focusmethod('trianingLevelfocusSearch')">
            <input type="search" id="trianingLevelfocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="trianingLevelsearchTxt" matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onLevelSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of trainingLevelDropdown | assessmentSearch :trianingLevelsearchTxt"
              (onSelectionChange)="onLevelSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <span id="trainingLevel-required-msg">Please select training level</span>
        </div>
        <div class="col-md-3" *ngIf="!visibleEditButton">
          <div><label for="email">Training Template</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedTrainingTemplate"
            [ngClass]="{'odd-item-mat-select': oddTrainingTemplate == selectedTrainingTemplate}"
            (closed)="trianingTemplatesearchTxt=''" (click)="focusmethod('trianingTemplatefocusSearch')"
            (keydown.enter)="focusmethod('trianingTemplatefocusSearch')">
            <input type="search" id="trianingTemplatefocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="trianingTemplatesearchTxt" matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onTemplateSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of trainingTemplateDropdown | assessmentSearch :trianingTemplatesearchTxt"
              (onSelectionChange)="onTemplateSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <!-- Due N Day From Assigned -->
          <div><label for="email">{{dynamicLabel['DUE_N_DAY_FROM_ASSIGNED']}}</label></div>
          <input id="dueNDayFromAssigned" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="trainingGroupTrainingFieldData.dueNDayFromAssigned" (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3">
          <!-- Remind N Day Before Due -->
          <div><label for="email">{{dynamicLabel['REMIND_N_DAY_BEFORE_DUE']}}</label></div>
          <input id="remindNDayBeforeDue" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="trainingGroupTrainingFieldData.remindNDayBeforeDue" (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3">
          <!-- Remind Every N Days -->
          <div><label for="email">{{dynamicLabel['REMIND_EVERY_N_DAYS']}}</label></div>
          <input id="remindEveryNDays" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="trainingGroupTrainingFieldData.remindEveryNDays" (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3">
          <!-- Escalate? -->
          <div><label for="email">{{dynamicLabel['ESCALATE']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="trainingGroupTrainingFieldData.escalate" (ngModelChange)="onEscalateChange()">
            <span class="active-inActive-container" *ngIf="trainingGroupTrainingFieldData.escalate==true"
              [ngStyle]="trainingGroupTrainingFieldData.escalate==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="trainingGroupTrainingFieldData.escalate==false"
              [ngStyle]="trainingGroupTrainingFieldData.escalate==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3" *ngIf="trainingGroupTrainingFieldData.escalate">
          <!-- Escalate Every N Days -->
          <div><label for="email">{{dynamicLabel['ESCALATE_EVERY_N_DAYS']}}</label></div>
          <input id="escalateEveryNDays" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="trainingGroupTrainingFieldData.escalateEveryNDays" (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3">
          <!-- Repeat Training? -->
          <div><label for="email">{{dynamicLabel['REPEAT_TRAINING']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="trainingGroupTrainingFieldData.repeatTraining" (ngModelChange)="onRepeatTrainingChange()">
            <span class="active-inActive-container" *ngIf="trainingGroupTrainingFieldData.repeatTraining==true"
              [ngStyle]="trainingGroupTrainingFieldData.repeatTraining==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="trainingGroupTrainingFieldData.repeatTraining==false"
              [ngStyle]="trainingGroupTrainingFieldData.repeatTraining==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3" *ngIf="trainingGroupTrainingFieldData.repeatTraining">
          <!-- Repeat Interval -->
          <div><label for="email">{{dynamicLabel['REPEAT_INTERVAL']}}</label></div>
          <input id="repeatInterval" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="trainingGroupTrainingFieldData.repeatInterval" (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3" *ngIf="trainingGroupTrainingFieldData.repeatTraining">
          <!-- Repeat Interval Unit -->
          <div><label for="email">{{dynamicLabel['REPEAT_INTERVAL_UNIT']}}</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedRepeatIntervalUnit"
            [ngClass]="{'odd-item-mat-select': oddRepeatIntervalUnit == selectedRepeatIntervalUnit}"
            (closed)="repeatIntervalUnitsearchTxt=''" (click)="focusmethod('repeatIntervalUnitfocusSearch')"
            (keydown.enter)="focusmethod('repeatIntervalUnitfocusSearch')">
            <input type="search" id="repeatIntervalUnitfocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="repeatIntervalUnitsearchTxt" matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onTemplateSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of repeatIntervalUnitDropdown | assessmentSearch :repeatIntervalUnitsearchTxt"
              (onSelectionChange)="onRepeatIntervalUnitSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <!-- Allowed Failed Attempts(A) -->
          <div><label for="email">{{dynamicLabel['ALLOWED_FAILED_ATTEMPTS']}}</label>
            <span matTooltip="The allowed number of assessment attempts before the training is locked(A)"
              matTooltipPosition="above" class="info-icon" style="margin-left: 5px; cursor: pointer;">
              <i class="fas fa-info-circle"></i>
            </span>
          </div>
          <input id="allowedFailedAttempts" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="trainingGroupTrainingFieldData.allowedFailedAttempts" (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3">
          <!-- Allowed Failed Attempts After Unlock(B) -->
          <div><label for="email">
              {{dynamicLabel['ALLOWED_FAILED_ATTEMPTS_AFTER_UNLOCK']}}</label> <span
              matTooltip="The allowed number of re-assessment attempts after being unlocked (B)"
              matTooltipPosition="above" class="info-icon" style="margin-left: 5px; cursor: pointer;">
              <i class="fas fa-info-circle"></i>
            </span></div>
          <input id="allowedFailedAttemptsAfterUnlock" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="trainingGroupTrainingFieldData.allowedFailedAttemptsAfterUnlock"
            (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3">
          <!-- Max Allowed Failed Attempts(C)(C > A+B) -->
          <div><label for="email">{{dynamicLabel['MAX_ALLOWED_FAILED_ATTEMPTS']}}</label>
            <span matTooltip="The maximum allowed attempts before the training gets permanently locked(C > A+ B)"
              matTooltipPosition="above" class="info-icon" style="margin-left: 5px; cursor: pointer;">
              <i class="fas fa-info-circle"></i>
            </span>
          </div>
          <input id="maxAllowedFailedAttempts" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="trainingGroupTrainingFieldData.maxAllowedFailedAttempts"
            (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3" *ngIf="trainingGroupTrainingFieldData.overdueQaApprovalReqd">
          <!-- List of QA Users -->
          <div><label for="email">{{dynamicLabel['LIST_OF_QA_USER_NAMES']}}</label> <span
              class="mandatory-symbol">*</span></div>
          <mat-select matInput multiple placeholder="Select" #listQAUsers [(ngModel)]="selectedQaUsers"
            id="listOfQAUsers" (closed)="listQAUsersSearchText=''" (click)="focusSearch('listQAUsersfocussearch')"
            (keydown.enter)="focusSearch('listQAUsersfocussearch')">
            <input type="search" id="listQAUsersfocussearch" class="dropdownsearchstyle"
              [(ngModel)]="listQAUsersSearchText" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isListQAUsersSelected" (change)="toggleAllSelection('listQAUsers')">Select
                All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of qaUsersListDropdown | multiAssessmentSearchPipe :listQAUsersSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onlistQAUsersSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
          <span id="listOfQAUsers-required-msg">Please select list of QA Users</span>
        </div>
        <div class="col-md-3">
          <!-- Due N Day from Overdue Unlock -->
          <div><label for="email">{{dynamicLabel['DUE_N_DAY_FROM_OVERDUE_UNLOCK']}}</label></div>
          <input id="dueNDayFromOverdueUnlock" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="trainingGroupTrainingFieldData.dueNDayFromOverdueUnlock"
            (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3">
          <!-- Retake After N Min on Failed Attempt -->
          <div><label for="email"> {{dynamicLabel['RETAKE_AFTER_N_MIN_ON_FAILED_ATTEMPT']}}</label></div>
          <input id="retakeAfterNMinOnFailedAttempt" class="input-filed-continers" type="number" min="1"
            [(ngModel)]="trainingGroupTrainingFieldData.retakeAfterNMinOnFailedAttempt"
            (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3">
          <!-- Allow to Review Results? -->
          <div><label for="email">{{dynamicLabel['ALLOW_TO_REVIEW_RESULTS']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="trainingGroupTrainingFieldData.allowToReviewResults">
            <span class="active-inActive-container" *ngIf="trainingGroupTrainingFieldData.allowToReviewResults==true"
              [ngStyle]="trainingGroupTrainingFieldData.allowToReviewResults==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="trainingGroupTrainingFieldData.allowToReviewResults==false"
              [ngStyle]="trainingGroupTrainingFieldData.allowToReviewResults==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3">
          <!-- Show Answers at Review? -->
          <div><label for="email">{{dynamicLabel['SHOW_ANSWERS_AT_REVIEW']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="trainingGroupTrainingFieldData.showAnswersAtReview">
            <span class="active-inActive-container" *ngIf="trainingGroupTrainingFieldData.showAnswersAtReview==true"
              [ngStyle]="trainingGroupTrainingFieldData.showAnswersAtReview==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="trainingGroupTrainingFieldData.showAnswersAtReview==false"
              [ngStyle]="trainingGroupTrainingFieldData.showAnswersAtReview==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3">
          <!-- Over Due RM Approval Reqd? -->
          <div><label for="email">{{dynamicLabel['OVERDUE_RM_APPROVAL_REQD']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="trainingGroupTrainingFieldData.overdueRmApprovalReqd">
            <span class="active-inActive-container" *ngIf="trainingGroupTrainingFieldData.overdueRmApprovalReqd==true"
              [ngStyle]="trainingGroupTrainingFieldData.overdueRmApprovalReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="trainingGroupTrainingFieldData.overdueRmApprovalReqd==false"
              [ngStyle]="trainingGroupTrainingFieldData.overdueRmApprovalReqd==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3">
          <!-- Over Due QA Approval Reqd? -->
          <div><label for="email">{{dynamicLabel['OVERDUE_QA_APPROVAL_REQD']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="trainingGroupTrainingFieldData.overdueQaApprovalReqd"(ngModelChange)="onOverdueQaApprovalReqdChange()">
            <span class="active-inActive-container" *ngIf="trainingGroupTrainingFieldData.overdueQaApprovalReqd==true"
              [ngStyle]="trainingGroupTrainingFieldData.overdueQaApprovalReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="trainingGroupTrainingFieldData.overdueQaApprovalReqd==false"
              [ngStyle]="trainingGroupTrainingFieldData.overdueQaApprovalReqd==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>

        <div class="col-md-3" *ngIf="operationFlag === 'EDIT'">
          <div><label for="updateReason">Update Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="updateReason" class="input-filed-continers" rows="3"
            [(ngModel)]="trainingGroupTrainingFieldData.updateReason"></textarea>
          <span id="updateReason-required-msg" style="display: none;">Please provide an update reason</span>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(trainingGroupTrainingFieldData)"
      (keydown.enter)="addAndEditFunction(trainingGroupTrainingFieldData)">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white" *ngIf="visibleAddButton">Add New</span>
      <span class="reload_text text-white" *ngIf="visibleEditButton">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Reason For Delete</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-continers" rows="4" cols="50"
            [(ngModel)]="trainingGroupTrainingFieldData.deleteReason"></textarea>
          <span id="deleteTextarea-required-msg">Please provide the reason for delete</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center gap-3 mx-3 button-continer" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #searchTraining>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchTrainingFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search Training </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div id="filed-container" class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Training Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Training Name"
          [(ngModel)]="searchByTrainingName">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Training Code</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Training Code"
          [(ngModel)]="searchByTrainingCode">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Category</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="categoryValue" (closed)="categorysearchTxt=''"
          (click)="focusmethod('categoryfocusSearch')" (keydown.enter)="focusmethod('categoryfocusSearch')">
          <input type="search" id="categoryfocusSearch" class="dropdownsearchstyle" [(ngModel)]="categorysearchTxt"
            matInput placeholder="Search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onCategorySelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of categoryDropdown | assessmentSearch :categorysearchTxt"
            (onSelectionChange)="onCategorySelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Language</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="languageValue" (closed)="languagesearchTxt=''"
          (click)="focusmethod('languagefocusSearch')" (keydown.enter)="focusmethod('languagefocusSearch')">
          <input type="search" id="languagefocusSearch" class="dropdownsearchstyle" [(ngModel)]="languagesearchTxt"
            matInput placeholder="Search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onLangaugeSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of languageDropdown | assessmentSearch :languagesearchTxt"
            (onSelectionChange)="onLangaugeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchTrainingGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchTrainingGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container" style="height: 50vh;">
        <thead>
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i id="parent-menu-icon" class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input type="checkbox" style="zoom: 1.2;" [checked]="searchTrainingParentCheckBox"
                  (change)="searchTrainingDataGridParentCheckBoxChecked($event)">
              </div>
            </div>
          </th>
          <th> <span>Training Name</span> <span class="fa-solid fa-filter" ></span> </th>
          <th> <span>Training Code</span> <span class="fa-solid fa-filter" id="multi-filter-trainingcode"></span> </th>
          <th> <span>Version</span> <span class="fa-solid fa-filter" id="multi-filter-version"></span> </th>
          <th> <span>Category</span> <span class="fa-solid fa-filter" id="multi-filter-category"></span> </th>
          <th> <span>Training Type</span> <span class="fa-solid fa-filter" id="multi-filter-type"></span> </th>
          <th> <span>Language</span> <span class="fa-solid fa-filter" id="multi-filter-language"></span> </th>
          <th id="menuitem" class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container"
            *ngFor="let listOfUsersVwDetails of getTmsTrainingDetailsTableData; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="listOfUsersVwDetails.searchTrainingChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2;"
                    [checked]="listOfUsersVwDetails.searchTrainingChildCheckBoxs"
                    (change)="searchTrainingChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ listOfUsersVwDetails.trainingName }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.trainingCode }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.version }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.categoryCode }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.type }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.language }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addTrainingNameFunction()" (keydown.enter)="addTrainingNameFunction()">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white ">Add New</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchTrainingFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #trainingGroupActiveInactivePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelTmsGroupActiveInActiveFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{popupTitle}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row">
      <div class="col-md-12">
        <div><label for="email">{{activeInactiveLabel}}</label><span class="mandatory-symbol">*</span></div>
        <textarea id="groupActiveInactiveReason" type="text" class="input-filed-textarea" rows="4" cols="50"
          [(ngModel)]="trainingGroupTrainingFieldData.groupActiveInactiveReason"></textarea>
        <span id="groupActiveInactiveReason-required-msg">Please provide the reason for {{errorMsgContent}} </span>
      </div>
    </div>

    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton"
        (click)="tmsGroupActiveInActiveFunction(trainingGroupTrainingFieldData)">
        <i class="fas fa-lock" *ngIf="!groupUserActionFlag"></i><i class="fas fa-lock-open"
          *ngIf="groupUserActionFlag"></i>
        {{activeInactiveButtonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelTmsGroupActiveInActiveFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>
<app-editor #clobViewPopup></app-editor>